<div class="d-flex gap-3">
  <div class="flex-fill d-flex flex-column gap-2">
    <div class="container-box shadow-none">
      <div class="p-3 d-flex align-items-center gap-3">
        <img src="/assets/images/channel-wizards/bdc/tokeet-bdc.webp" alt="" height="45" />
        <div>
          <h6 class="mb-0" i18n>Booking.com</h6>
          <div class="text-sm" i18n>
            Connect multiple Booking.com accounts and sync bookings, prices, guest messages, and more instantly.
          </div>
        </div>
      </div>
      <div class="border-top p-3">
        <ng-container i18n
          >Connection between AdvanceCM and Booking.com, offering numerous advantages, including unparalleled
          reliability. Bookings, inquiries, requests, and guest conversations sync instantly. Connect as many
          Booking.com accounts as needed, and AdvanceCM will automatically import your listings in
          seconds.</ng-container
        >
        <div class="d-flex gap-2 align-items-center mt-3">
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Listing Creation</span>
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Rates</span>
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Bookings</span>
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Availabilities</span>
        </div>
      </div>
    </div>

    <div class="container-box shadow-none p-3">
      <h6 i18n>How to connect to Booking.com</h6>
      <div i18n>
        Booking.com is one of Tokeet’s preferred partners. This means we import your listings from Booking.com and allow
        you to connect them to other platforms like Booking.com, Vrbo (HomeAway), and more.
      </div>
    </div>

    <div class="container-box shadow-none">
      <div class="p-3">
        <h6 i18n>Connecting to Booking.com with AdvanceCM is easy and efficient</h6>
        <div>
          <ng-container i18n>Use the 'Connect' option for a detailed process walkthrough.</ng-container> <br />
          <ng-container i18n>For a detailed guide,</ng-container>
          <a href="javascript:;" openArticleId="2mx4rvnhrd" i18n>click here for a step-by-step guide</a>.
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-3 border-top p-3">
        <button class="btn btn-secondary-info" (click)="next.emit()">
          <ng-container i18n>Connect</ng-container>
          <i class="cs-icon cs-icon-link"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/bdc/step1.webp" alt="" class="w-100" />
  </div>
</div>
